import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { GenerativeAIServiceTick } from "../../../../app-constants";

function Realappprocess() {
  return (
    <section
      className="real_app_process p-100"
      style={{ background: "#fafafa" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Our <span>Real Estate Mobile</span> Application Development
              Process
            </h2>
            <p>
              As a premier real estate mobile app development company, we
              implement an agile development methodology to craft effective real
              estate app solutions.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="app-process-main">
              <div className="app-process-item">
                <div className="app-process-box">
                  <div className="app-process-svg">
                    {GenerativeAIServiceTick}
                  </div>
                  <div className="app-process-content">
                    <h5>Idea Generation and Approach</h5>
                    <p>
                      Our expert real estate app developers conduct a thorough
                      analysis of market trends to define the app's goals,
                      identify the target audience, and highlight its unique
                      selling points.
                    </p>
                  </div>
                </div>
              </div>
              <div className="app-process-item">
                <div className="app-process-box">
                  <div className="app-process-svg">
                    {GenerativeAIServiceTick}
                  </div>
                  <div className="app-process-content">
                    <h5>
                      Market
                      <br /> Analysis
                    </h5>
                    <p>
                      After that, our experts in real estate software
                      development carry out a thorough analysis of the market,
                      client preferences, and rivals to identify potential areas
                      for innovation and a competitive edge.
                    </p>
                  </div>
                </div>
              </div>
              <div className="app-process-item">
                <div className="app-process-box">
                  <div className="app-process-svg">
                    {GenerativeAIServiceTick}
                  </div>
                  <div className="app-process-content">
                    <h5>User Experience Design and Prototyping</h5>
                    <p>
                      Our design team produces wireframes and mockups that
                      complement the app's branding to accurately depict the
                      layout and user path, guaranteeing a simple and
                      eye-catching interface.
                    </p>
                  </div>
                </div>
              </div>
              <div className="app-process-item">
                <div className="app-process-box">
                  <div className="app-process-svg">
                    {GenerativeAIServiceTick}
                  </div>
                  <div className="app-process-content">
                    <h5>
                      Frontend & Backend
                      <br /> Development
                    </h5>
                    <p>
                      Our real estate app developers design the frontend and
                      select key features. Meanwhile, they build the server,
                      databases, APIs, and backend for seamless functionality.
                    </p>
                  </div>
                </div>
              </div>
              <div className="app-process-item">
                <div className="app-process-box">
                  <div className="app-process-svg">
                    {GenerativeAIServiceTick}
                  </div>
                  <div className="app-process-content">
                    <h5>
                      Quality
                      <br /> Assurance
                    </h5>
                    <p>
                      The application is put through extensive testing by our QA
                      specialists to make sure it is safe, effective, and
                      compatible with common devices and systems.
                    </p>
                  </div>
                </div>
              </div>
              <div className="app-process-item">
                <div className="app-process-box">
                  <div className="app-process-svg">
                    {GenerativeAIServiceTick}
                  </div>
                  <div className="app-process-content">
                    <h5>
                      Deployment
                      <br /> and Launch
                    </h5>
                    <p>
                      Following testing, our team advances to the next phase,
                      which is submitting the app to the Android and iOS app
                      stores to ensure that it satisfies all requirements before
                      it is released onto the market.
                    </p>
                  </div>
                </div>
              </div>
              <div className="app-process-item">
                <div className="app-process-box">
                  <div className="app-process-svg">
                    {GenerativeAIServiceTick}
                  </div>
                  <div className="app-process-content">
                    <h5>Ongoing Maintenance and Support</h5>
                    <p>
                      Our team monitors user involvement and feedback following
                      the launch. We regularly update the app with new features,
                      improvements, and bug fixes to ensure the best user
                      experience.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Realappprocess;
